module.exports = __webpack_public_path__ + "static/media/stop-bg.01feb405.svg";